import { PRIORITY_FEATURE_NAMES, SEAT_FEATURES } from "@flights/branded-fares";
import { createTrackingUtils } from "../index.js";
import { getMarketingCarriers } from "../../../utils/getCarrierCombinations.js";
const utils = createTrackingUtils({
    name: "flights_apex_web_bf_table_ddot",
    stages: {
        main: 1,
        multi_travellers: 2,
        multi_traveller_infant: 3,
        diff_baggage_allowances: 4,
        base_without_checked_bag: 5,
        priority_features_avail: 6,
        diff_seat_features_shown: 7,
        sees_carousel_table: 8,
        is_preferred_carriers: 9
    },
    defaultStage: 1,
    goals: {}
});
function getCheckedBagPiecePerPax(includedProducts) {
    if (!includedProducts?.segments?.[0])
        return 0;
    const checkedBag = includedProducts.segments[0].find((item) => item.luggageType === "CHECKED_IN");
    if (!checkedBag)
        return 0;
    return checkedBag.piecePerPax ?? checkedBag.maxPiece ?? 0;
}
function hasDiffBaggageAllowances(offers) {
    const baggageEntries = offers
        .map((offer) => {
        if (!offer.includedProducts?.segments?.[0])
            return undefined;
        return offer.includedProducts.segments[0].find((item) => item.luggageType === "CHECKED_IN");
    })
        .filter((entry) => Boolean(entry));
    if (baggageEntries.length < 2)
        return false;
    const first = baggageEntries[0];
    return baggageEntries.some((entry) => (entry.piecePerPax ?? entry.maxPiece) !== (first.piecePerPax ?? first.maxPiece) ||
        (entry.maxWeightPerPiece ?? 0) !== (first.maxWeightPerPiece ?? 0));
}
function hasPriorityFeatures(offers) {
    const prioritySet = new Set(PRIORITY_FEATURE_NAMES);
    return offers.some((offer) => offer.brandedFareInfo.featuresList?.some((f) => prioritySet.has(f.featureName) && f.availability !== "NOT_INCLUDED"));
}
function hasDiffSeatFeatures(offers) {
    const seatSet = new Set(SEAT_FEATURES);
    const seatFeatureNames = new Set();
    for (const offer of offers) {
        const seatFeature = offer.brandedFareInfo.featuresList?.find((f) => seatSet.has(f.featureName) && f.availability === "INCLUDED");
        if (seatFeature) {
            seatFeatureNames.add(seatFeature.featureName);
        }
    }
    return seatFeatureNames.size > 1;
}
function trackStages({ brandedFareOffers, flight, isMultiTraveller, hasInfant }) {
    if (isMultiTraveller) {
        utils.stages.multi_travellers();
    }
    if (hasInfant) {
        utils.stages.multi_traveller_infant();
    }
    if (hasDiffBaggageAllowances(brandedFareOffers)) {
        utils.stages.diff_baggage_allowances();
    }
    if (brandedFareOffers[0]?.includedProducts?.segments?.[0] &&
        getCheckedBagPiecePerPax(brandedFareOffers[0].includedProducts) === 0) {
        utils.stages.base_without_checked_bag();
    }
    if (hasPriorityFeatures(brandedFareOffers)) {
        utils.stages.priority_features_avail();
    }
    if (hasDiffSeatFeatures(brandedFareOffers)) {
        utils.stages.diff_seat_features_shown();
    }
    if (brandedFareOffers.length >= 3) {
        utils.stages.sees_carousel_table();
    }
    if (getMarketingCarriers(flight.segments).length > 0) {
        utils.stages.is_preferred_carriers();
    }
}
export default { ...utils, trackStages };
